module.exports = __webpack_public_path__ + "fonts/quicksand-v20-latin-300.545af326.woff2";